<template>
  <Modal
    :headline="$t('myVocabulary.chooseColor')"
    :show-modal="showModal"
    :show-save-btn="false"
    :show-cancel-btn="false">
    <v-swatches
      v-model="localColor"
      inline
      @input="updateColor" />
    <v-btn
      v-if="renderButton"
      slot="activator"
      :color="localColor"
      block
      outlined
      @click="onOpen">
      <v-icon left small>palette</v-icon>
      {{ $t('myVocabulary.changeColor') }}
    </v-btn>
    <v-btn
      v-else
      slot="activator"
      fab
      :style="`background: ${localColor}`"
      @click="onOpen" />
  </Modal>
</template>

<script>
import Modal from '@components/modal';
import VSwatches from 'vue-swatches';

export default {
  name: 'ColorChooser',
  components: {
    Modal,
    VSwatches,
  },
  props: {
    renderButton: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'blue',
    },
  },
  data: () => ({
    showModal: false,
    localColor: 'blue',
  }),
  methods: {
    onOpen() {
      this.showModal = true;
      this.localColor = this.color;
    },
    updateColor() {
      this.showModal = false;
      this.$emit('update:color', this.localColor);
    },
  },
  created() {
    this.localColor = this.color;
  },
};
</script>
